import i18n from "i18nt";
import { PAGES } from "./pages";

export const headerNavigationConstants = [
  PAGES.HOME,
  PAGES.ABOUT,
  {
    title: i18n.t("pages.ourWork"),
    dropdown: [PAGES.CASE_STUDIES, PAGES.HOW_WE_CAN_HELP],
  },
  PAGES.CAREERS,
  //PAGES.OPEN_POSITIONS,
  PAGES.CONTACT,
];
export const footerNavigationConstants = [
  PAGES.HOME,
  PAGES.ABOUT,
  PAGES.CAREERS,
];
